import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@mui/material";

interface IConfirmDialouge {
    openDialog: boolean;
    onConfirm: () => void;
    onClose: () => void;
    text: confirmDialog;
}
const ConfirmDialog: React.FC<IConfirmDialouge> = ({ openDialog, onConfirm, onClose, text }) => {

    return (
        <Dialog
            open={openDialog}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {text.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {text.description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        onClose();
                        onConfirm();
                    }}
                    autoFocus
                >
                    {text.confirmButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDialog;